export default __webpack_public_path__ + "static/media/w300.ac0e54bd.png";